import React from "react";

import { useCreateSwapRequestContext } from "../context";
import { TabTypes } from "../types";
import ExactGetContent from "./ExactGetContent";
import ExactPayContent from "./ExactPayContent";

const Content = () => {
  const { activeTabId } = useCreateSwapRequestContext();
  const isExactPayTab = activeTabId === TabTypes.EXACT_PAY;

  return <>{isExactPayTab ? <ExactPayContent /> : <ExactGetContent />}</>;
};

export default Content;
